import React, { useEffect } from 'react';
import { Form, Input, Button, Layout, Row, Col } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import './style.css';
import { useTranslation } from 'react-i18next';
import { LOGIN_TYPES } from '../../utils/constant';
//import { history } from 'umi';

const { Content } = Layout;

interface LoginProps {
  loading: boolean;
  resetForm?: boolean;
  onFinish: (values: any) => void;
  loginType: string;
  onForgotPassword?: (values: any) => void;
  backToLogin: () => void;
}

const Login: React.FC<LoginProps> = (props) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields(['password', 'currentPassword', 'newPassword', 'confirmPassword']);
  }, [props.resetForm]);

  return (
    <Content className="login-content">
      <Row gutter={[0, 0]} >
        <Col xs={0} sm={0} md={0} lg={13} xl={13} className='homePageImg'>
        </Col>
        <Col xs={24} sm={24} md={24} lg={11} xl={11} className='loginForm' style={{ background: '#FFF' }}>
          <Row gutter={[0, 0]} justify="space-around">
            <Col xs={24} sm={24} md={12} lg={24} xl={24} className='container'>
              <Form
                name="login"
                form={form}
                initialValues={{ remember: true }}
                onFinish={props.onFinish}
                layout="vertical"
                //style={{ height: 'auto', margin: '10px 15% 0', textAlign: 'left' }}
                className='centered-div'
              >

                <h3 className="login-title" style={{ margin: '0 0 20px 0' }}>
                  {props.loginType === LOGIN_TYPES.FORGOT_PASSWORD ? t('login.forgot-password.title')
                    : props.loginType === LOGIN_TYPES.RESET_PASSWORD ? t('login.reset-password.title')
                      : props.loginType === LOGIN_TYPES.CHANGE_PASSWORD ? t('login.change-password.title')
                        : t('login.title')}
                </h3>

                <Form.Item
                  label={t('email')}
                  name="email"
                  rules={[{ required: true, message: t("email.required.msg") },
                  { type: 'email', message: t('user-management.email.invalid') },  // checks if it's a valid email format
                  { max: 320, message: t('user-management.email.max.msg') },

                  ]}>
                  <Input placeholder={t('email.placeholder')}
                    className="login-input" />
                </Form.Item>

                {props.loginType === LOGIN_TYPES.LOGIN &&
                  <Form.Item
                    label={t('password')}
                    name="password"
                    rules={[{ required: props.loginType === LOGIN_TYPES.LOGIN, message: t("password.required.msg") }]}>
                    <Input.Password
                      placeholder={t('password.placeholder')}
                      iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                      className="login-input" />
                  </Form.Item>}

                {props.loginType === LOGIN_TYPES.CHANGE_PASSWORD &&
                  <Form.Item
                    label={t('old-password')}
                    name="currentPassword"
                    rules={[{ required: props.loginType === LOGIN_TYPES.CHANGE_PASSWORD, message: t("password.old.required.msg") }]}>
                    <Input.Password
                      placeholder={t('old-password.placeholder')}
                      iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                      className="login-input" />
                  </Form.Item>}

                {(props.loginType === LOGIN_TYPES.CHANGE_PASSWORD || props.loginType === LOGIN_TYPES.RESET_PASSWORD) &&
                  <>
                    <Form.Item
                      label={t('new-password')}
                      name="newPassword"
                      rules={[{ required: (props.loginType === LOGIN_TYPES.CHANGE_PASSWORD || props.loginType === LOGIN_TYPES.RESET_PASSWORD), message: t("password.new.required.msg") }]}>
                      <Input.Password
                        placeholder={t('new-password.placeholder')}
                        iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                        className="login-input" />
                    </Form.Item>

                    <Form.Item
                      label={t('confirm-new-password')}
                      name="confirmPassword"
                      dependencies={['newPassword']}
                      rules={[{ required: (props.loginType === LOGIN_TYPES.CHANGE_PASSWORD || props.loginType === LOGIN_TYPES.RESET_PASSWORD), message: t("password.confirm.required.msg") },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('newPassword') === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error(t('confirm-new-password.err.msg.do-not-match')));
                        },
                      }),
                      ]}>
                      <Input.Password
                        placeholder={t('confirm-new-password.placeholder')}
                        iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                        className="login-input" />
                    </Form.Item>
                  </>}

                <Form.Item>
                  <Button type="primary" htmlType="submit" block loading={props.loading} className="login-button">
                    {props.loginType === LOGIN_TYPES.FORGOT_PASSWORD ? t('btn.send-link')
                      : props.loginType === LOGIN_TYPES.RESET_PASSWORD ? t('login.reset-password.title')
                        : props.loginType === LOGIN_TYPES.CHANGE_PASSWORD ? t('login.change-password.title')
                          : t('btn.login')}
                  </Button>
                </Form.Item>

                {props.loginType === LOGIN_TYPES.LOGIN &&
                  <Form.Item>
                    <Button type="link" block className="login-forgot-password"
                      onClick={() => props?.onForgotPassword?.(LOGIN_TYPES.FORGOT_PASSWORD)}>
                      {t('btn.forgot-password')}
                    </Button>
                  </Form.Item>
                }


                {props.loginType === LOGIN_TYPES.FORGOT_PASSWORD &&
                  <Form.Item style={{ textAlign: 'center' }}>
                    <Button type="link" onClick={props.backToLogin} block className="login-forgot-password"
                    >
                      {t('back.button')}
                    </Button>

                  </Form.Item>
                }
              </Form>
              
            </Col> 
          </Row>
          
        </Col>
      </Row>
      <Row className='d-flex justify-content-around omdp_logo' gutter={[0, 0]} style={{background:'#ffffff'}}> 
            <Col xs={24} sm={24} md={24} lg={2} xl={2} className='loginPageLogo mpl'></Col>
            <Col xs={24} sm={24} md={24} lg={2} xl={2} className='loginPageLogo lbs'></Col>
            <Col xs={24} sm={24} md={24} lg={2} xl={2} className='loginPageLogo dri'></Col>
            <Col xs={24} sm={24} md={24} lg={2} xl={2} className='loginPageLogo mfa'></Col>
            <Col xs={24} sm={24} md={24} lg={2} xl={2} className='loginPageLogo mha'></Col>
            <Col xs={24} sm={24} md={24} lg={2} xl={2} className='loginPageLogo mlsw'></Col>
            <Col xs={24} sm={24} md={24} lg={2} xl={2} className='loginPageLogo mps'></Col>
            <Col xs={24} sm={24} md={24} lg={2} xl={2} className='loginPageLogo mes'></Col>
            <Col xs={24} sm={24} md={24} lg={2} xl={2} className='loginPageLogo mtc'></Col>
            <Col xs={24} sm={24} md={24} lg={2} xl={2} className='loginPageLogo blp'></Col>
            <Col xs={24} sm={24} md={24} lg={2} xl={2} className='loginPageLogo lwu'></Col> 
            {/* <ul>
              <li className='mpl'></li> 
              <li className='lbs'></li>
              <li className='dri'></li> 
              <li className='mfa'></li> 
              <li className='mha'></li>
              <li className='mlsw'></li> 
              <li className='mps'></li> 
              <li className='mes'></li>
              <li className='mtc'></li> 
              <li className='blp'></li>
              <li className='lwu'></li> 
            </ul>
            </Col> */}
          </Row>
    </Content>
  );
};

export default Login;